import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Message } from 'botframework-directlinejs';

import { hashMerge } from './utilites';

export interface Feedback01Props {
    message: Message;
    onCardAction: (type: string, value: string) => void;
    userDefined: any;
}

export interface Feedback01State {
    currentState: string;
    eval: number;
    sent: boolean;
    feedbackEntitiy: any;
    stopAfterSelectGood: boolean;
    stopAfterSelectBad: boolean;
}

export class Feedback01View extends React.Component<Feedback01Props, Feedback01State> {

    private strings : {
        firstMsg : string,
        goodMsg : string,
        badMsg : string
    }

    constructor(props: Feedback01Props) {
        super(props);

        this.strings = {
            firstMsg : "ご案内はお役に立ちましたか？",
            goodMsg : "ありがとうございます！お役に立てて嬉しいです。",
            badMsg : "大変申し訳ありません。お役に立てるよう努力します。"
        };

        if (this.props.userDefined.strings) {
            this.strings = hashMerge(this.strings, this.props.userDefined.strings);
        }

        this.state = {
            currentState : "wait",
            eval : 0,
            sent : false,
            feedbackEntitiy : (this.props.message.entities || []).find((x:any) => x.feedback),
            stopAfterSelectGood : false,
            stopAfterSelectBad : false
        };
    }

    // Good送信
    sendGood = () => {
        let value = JSON.stringify({
            "cmd": "feedback",
            "key": (this.props.message.entities || []).find((x:any) => x.feedback).feedback,
            "value": 1
        });

        this.setState({
            sent : true,
            eval : 1,
            currentState : "send-good"
        });

        this.props.onCardAction("postBack", value);

        if (this.props.userDefined.afterSelectGood) {
            const stopFlag = this.props.userDefined.afterSelectGood({
                element : ReactDOM.findDOMNode(this),
                onCardAction : this.props.onCardAction,
                values : {
                    "cmd": "feedback",
                    "key": (this.props.message.entities || []).find((x) => x.feedback).feedback,
                    "comment": "",
                    "value": 1
                }
            });

            if (stopFlag) {
                this.setState({ stopAfterSelectGood : true });
            } else {
                this.setState({ stopAfterSelectGood : false });
            }
        }
    }

    // Bad送信
    sendBad = () => {
        let value = JSON.stringify({
            "cmd": "feedback",
            "key": (this.props.message.entities || []).find((x:any) => x.feedback).feedback,
            "value": -1
        });

        this.setState({
            sent: true,
            eval: -1,
            currentState : "send-bad"
        });

        this.props.onCardAction("postBack", value);

        if (this.props.userDefined.afterSelectBad) {
            const stopFlag = this.props.userDefined.afterSelectBad({
                element : ReactDOM.findDOMNode(this),
                onCardAction : this.props.onCardAction,
                values : {
                    "cmd": "feedback",
                    "key": (this.props.message.entities || []).find((x:any) => x.feedback).feedback,
                    "comment": "",
                    "value": -1
                }
            });

            if (stopFlag) {
                this.setState({ stopAfterSelectBad : true });
            } else {
                this.setState({ stopAfterSelectBad : false });
            }
        }
    };

    componentDidMount() {
        if (this.props.userDefined.enable && this.props.userDefined.init) {
            this.props.userDefined.init({
                element : ReactDOM.findDOMNode(this),
                onCardAction : this.props.onCardAction,
                status : this.state
            });
        }
    }

    render() {
        return (
            <div className='osk-feedback'>
                { !this.state.sent ? (
                    <div>
                        <p>{ this.strings.firstMsg }</p>
                        <div className="buttons">
                            <button type="button" className="osk-good" onClick={ this.sendGood }>はい</button>
                            <button type="button" className="osk-bad" onClick={ this.sendBad }>いいえ</button>
                        </div>
                    </div>
                ) : null }

                { this.state.currentState === "send-good" ? <p className="send-message">{ this.strings.goodMsg }</p> : null }
                { this.state.currentState === "send-bad" ? <p className="send-message">{ this.strings.badMsg }</p> : null }
            </div>
        );
   }
}


// WEBPACK FOOTER //
// ./src/Feedback01.tsx